import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const deleteProjectDetailApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.TICKET.DELETE_PROJECT_DETAIL,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deleteProjectDetailApi;